/**
 * @lines98/client/lib/theme — тема приложения (светлая `retro` / тёмная `dark`).
 *
 * ОДИН переиспользуемый модуль (CLAUDE.md «код через модули»): и boot (`main.ts`
 * applyTheme до первого экрана), и контрол настроек (`components/theme-switch`)
 * ходят сюда, не дублируя ни знание значений, ни запись в DOM/persist.
 *
 * Значение — `documentElement.dataset.theme` (CSS `[data-theme='retro'|'dark']` в
 * global.css задают палитру токенов). Источник правды — `lib/client-prefs` (`theme`,
 * versioned/persisted). Тема приложения НЕЗАВИСИМА от скина доски (§5.5 / CLAUDE.md).
 *
 * NB: `index.html` head-сниппет применяет сохранённую тему ДО первой отрисовки
 * (без вспышки); этот модуль — единый API для рантайма (читать/менять/применить).
 */

import { getClientPrefs, setPref, type AppTheme } from './client-prefs.js';

export type { AppTheme };

/** Текущая тема (из persisted prefs). */
export function getTheme(): AppTheme {
  return getClientPrefs().theme;
}

/** Применить тему к DOM (`documentElement.dataset.theme`). Без записи в prefs. */
export function applyTheme(theme: AppTheme): void {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = theme;
}

/** Сменить тему: persist (`client-prefs`) + применить к DOM. */
export function setTheme(theme: AppTheme): void {
  setPref('theme', theme);
  applyTheme(theme);
}

/** Boot: применить сохранённую тему к DOM (идемпотентно с head-сниппетом). */
export function initTheme(): void {
  applyTheme(getTheme());
}
